import { render } from "./Precision.vue?vue&type=template&id=6dfb7162&scoped=true"
import script from "./Precision.vue?vue&type=script&lang=js"
export * from "./Precision.vue?vue&type=script&lang=js"

import "./Precision.vue?vue&type=style&index=0&id=6dfb7162&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfb7162"]])

export default __exports__